export const tableLabel = [
  {
    label: '需求计划编号',
    param: 'purchaseDemandCode',
    align: 'center',
    minWidth: 140,
    slot: 'purchaseDemandCode',
  },
  {
    label: '需求计划名称',
    param: 'purchaseDemandName',
    align: 'center',
    minWidth: 140,
  },
  {
    label: '创建日期',
    param: 'createTime',
    align: 'center',
    minWidth: 180,
  },
  {
    label: '需求申请人',
    param: 'createMemberName',
    align: 'center',
    minWidth: 110,
  },
  {
    label: '状态',
    param: 'purchaseDemandStatus',
    align: 'center',
    slot: 'purchaseDemandStatus',
    minWidth: 100,
  },
  {
    label: '操作',
    align: 'center',
    fixed: 'right',
    width: '140',
    slot: 'handle',
    minWidth: 100,
  },
];

export const fieldList = [
  {
    label: '中文名称',
    type: 'input',
    value: 'purchaseDemandName',
  },
  {
    label: '英文名称',
    type: 'input',
    value: 'purchaseDemandCode',
  },
  {
    label: '审核状态',
    type: 'select',
    value: 'brandAuditStatus',
    list: 'brandAuditStatusList',
  },
];

export const listTypeInfo = {
  brandAuditStatusList: [
    { name: '全部', id: '' },
    { name: '未提交审核', id: 0 },
    { name: '审核中', id: 1 },
    { name: '审核通过', id: 2 },
    { name: '审核拒绝', id: 3 },
  ],
};
